<p-toast position="bottom-right" [style]="{ marginTop: '25px' }" [baseZIndex]="5000"></p-toast>

<p-toast key="notify" #toast position="bottom-right" (onClose)="onClose($event)" [baseZIndex]="5000" [preventOpenDuplicates]="true">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <div class="text-center">
          @switch (message.data.typeNotif) {
            @case ('4') {
              <p class="white-space">{{message.detail}}</p>
            }
            @case ('6') {
              <p class="white-space">{{message.detail}}</p>
            }
            @default {
              <p>{{message.detail}}</p>
            }
          }
        </div>
      </div>
      <div class="grid p-fluid">
        <div class="col-12">
          @if (message.data.typeNotif !==4 && message.data.typeNotif !==6 && message.data.stateNotif !==7) {
            <button type="button" pButton (click)="onConfirm(message.data)" label="{{'Batch_DwnLoad' | translate}}" class="p-button-success"></button>
          }
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<loader></loader>
@if (loading) {
    <app-waiting [visible]="true"></app-waiting>
}
@if (!loading) {
    <router-outlet></router-outlet>
}